import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import { bg_button } from "constant/css";

const BANKS = [
  { id: null, name: "сонго" },
  { id: "050000", name: "Хаан банк" },
  { id: "340000", name: "Төрийн банк" },
  { id: "150000", name: "Голомт банк" },
  { id: "390000", name: "М Банк" },
  { id: "040000", name: "Худалдаа хөгжлийн банк" },
  { id: "300000", name: "Капитрон банк" },
  { id: "320000", name: "Хас банк" },
];

const BankSelectModal = ({ open, close, save, value }) => {
  const [bankCode, setBankCode] = useState(value ?? null);

  useEffect(() => {
    if (open) setBankCode(value ?? null);
  }, [open, value]);

  return (
    <Modal
      open={!!open}
      closeIcon={null}
      width={280}
      footer={null}
      title="Банк сонгох"
      onCancel={close}
      zIndex={1100}
      destroyOnClose
    >
      <Select
        value={bankCode}
        onChange={setBankCode}
        style={{ width: "100%" }}
        placeholder="Банк сонгох"
        getPopupContainer={(trigger) => trigger.parentElement}
      >
        {BANKS.filter((b) => b.id != null).map((bank) => (
          <Select.Option key={bank.id} value={bank.id}>
            {bank.name}
          </Select.Option>
        ))}
      </Select>
      <div className="flex flex-col gap-2 mt-4 w-full items-center">
        <button
          className={`${bg_button} text-white items-center justify-center rounded-md flex center w-[100px]`}
          onClick={() => save(bankCode)}
          disabled={!bankCode}
        >
          Хадгалах
        </button>
      </div>
    </Modal>
  );
};

export default BankSelectModal;
